import { Github } from "lucide-react";
import { Link } from "react-router-dom";
import { CALENDAR_URL, GITHUB_URL } from "@/lib/site";
import { BrandLogo } from "./BrandLogo";

// "theme" for pages that follow the --l-* light/dark theme (legal);
// default is the light enterprise style.
export function PublicHeader({ variant }: { variant?: "theme" }) {
  return (
    <nav className={variant ? `public-header public-header--${variant}` : "public-header"} aria-label="Primary navigation">
      <div className="public-header__inner">
        <BrandLogo to="/" className="public-header__brand" height={34} />
        <div className="public-header__actions">
          <Link className="public-header__signin" to="/login">Sign In</Link>
          <a className="public-header__github" href={GITHUB_URL} target="_blank" rel="noreferrer" aria-label="Star on GitHub">
            <Github aria-hidden="true" />
            <span>Star on GitHub</span>
          </a>
          <a className="public-header__call" href={CALENDAR_URL} target="_blank" rel="noreferrer">
            Book Demo
          </a>
        </div>
      </div>
    </nav>
  );
}
